import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import service from '../service';
import type { SubscriptionTier } from '../types/fish';

export const subscriptionTierQueryKeys = {
  all: ['subscriptionTiers'] as const,
  options: () => [...subscriptionTierQueryKeys.all, 'options'] as const,
};

/**
 * Every non-deleted subscription tier, ordered by title. Reads the public tier list, so staff who
 * manage invite codes need no subscription permission to pick tiers.
 */
export function useSubscriptionTiers({
  enabled = true,
}: { enabled?: boolean } = {}): UseQueryResult<SubscriptionTier[], Error> {
  return useQuery<SubscriptionTier[], Error>({
    queryKey: subscriptionTierQueryKeys.options(),
    enabled,
    queryFn: async () => {
      const res = await service.getSubscriptionTiers();
      if (!res.ok) {
        throw Object.assign(
          new Error(`Error loading subscription tiers (${res.status})`),
          { status: res.status },
        );
      }
      const tiers: SubscriptionTier[] = await res.json();
      return [...tiers].sort((a, b) => a.title.localeCompare(b.title));
    },
  });
}
